/**
 * Adds event listener to element
 * @param {Element} node
 * @param {string} eventName
 * @param {function} listener
 * @param {boolean} shouldCapture
 */
export function addEvent(
    node: any,
    eventName: string,
    listener: (event: any) => void,
    shouldCapture?: boolean,
) {
    if (node.attachEvent) {
        node.attachEvent(`on${eventName}`, listener);
    } else {
        node.addEventListener(eventName, listener, shouldCapture);
    }
}
